import React from 'react';
import { timezone_diff } from './TimezoneDiff';

export function DisplayTimeDiff({ timezone, local_timezone }) {
  return <>{timezone_diff(timezone, local_timezone)}</>;
}